import React, { Component, Fragment } from "react";
import { DatePicker } from "@material-ui/pickers";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import PropTypes from "prop-types";
import ValidatedField from "./FieldValidator/ValidatedField";

class DateField extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired
    }

    render() {
        const { name, value, label, setValue, min, year, future, ...props } = this.props;
        return (
            <Fragment>
                <ValidatedField
                    name={name}
                    component="span"
                    hidden
                />
                {label &&
                    <span style={{position:"relative", top:"24px", color:"rgba(0,0,0,0.54)"}}>
                        {label}
                    </span>
                }
                <DatePicker
                    okLabel=""
                    cancelLabel=""
                    onChange={setValue}
                    value={value}
                    minDate={min}
                    openToYearSelection={year}
                    disableFuture={future}
                    autoOk
                    emptyLabel={'Please select date'}
                    clearable
                    format="DD/MM/YYYY"

                    {...props}
                />
            </Fragment>
        );
    }

}

function mapStateToProps( state, ownProps ) {
    const selector = formValueSelector( ownProps.form );
    const value = selector( state, ownProps.name );
    return {
        name: ownProps.name,
        value: value || null // Stops default date being today
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        setValue: ( value ) => dispatch( change( ownProps.form, ownProps.name, value ) )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( DateField );